export const MAX_DOCS_NUMBER = 3
